import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { FiSearch } from "react-icons/fi";
import { IoExitOutline } from "react-icons/io5";
import { TbArrowBackUp } from "react-icons/tb";
import { RiSave2Fill } from "react-icons/ri";
import { CiSearch } from "react-icons/ci";
import { GrUndo } from "react-icons/gr";
import { IoAdd } from "react-icons/io5";
import { RiFileExcel2Fill } from "react-icons/ri";
import { MdDeleteForever } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_HOST } from "../api_utils";
import { toast } from "react-toastify";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaGripLinesVertical, FaUndo } from "react-icons/fa";

import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import {
  Autocomplete,
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import Loader from "../Shared_Components/Loader";

function Loans(props) {
  const { userDataFromStorage, coloredTheme } = props;
  let navigate = useNavigate();

  const [loanDetail, setLoanDetail] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentData, setCurrentData] = useState([]);
  const [customerListForAgent, setCustomerListForAgent] = useState([]);

  // admin loan overview states:
  const [loanOverViewByAdmin, setLoanOverViewByAdmin] = useState({});
  const [loanOverViewByManager, setLoanOverViewByManager] = useState({});
  const [loanOverViewByAgent, setLoanOverViewByAgent] = useState({});

  // STATES FOR PAGINATION:
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const [totalPages, setTotalPages] = useState(0);
  const [closeLoanSuccess, setCloseLoanSuccess] = useState(false);

  // states for filter:
  const [managerLastName, setManagerLastName] = useState("");
  const [agentLastName, setAgentLastName] = useState("");
  const [startBefore, setStartBefore] = useState("");
  const [startAfter, setStartAfter] = useState("");
  const [loanStatus, setLoanStatus] = useState("Active");
  const [nickname, setNickname] = useState("");
  const [filterData, setFilterData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [openLoanCloseReason, setOpenLoanCloseReason] = useState(false);
  const [closeLoanReason, setCloseLoanReason] = useState("");
  const [selectedLoanToClose, setSelectedCloseToClose] = useState("");
  const [loanOverViewScreen, setLoanOverViewScreen] = useState(false);
  const [currentLoanCustomerData, setCurrentLoanCustomerData] = useState({});

  const [currentLoanOverViewLoading, setCurrentLoanOverViewLoading] =
    useState(false);
  const [currentLoanOverViewDetail, setCurrentLoanOverViewDetail] = useState(
    {}
  );

  const [newTransactionModelOpen, setNewTransactionModelOpen] = useState(false);

  const [loanOverViewStartDate, setLoanOverViewStartDate] = useState("");

  const singaporeTimezone = "Asia/Singapore";
  const currentDateInSingapore = new Date().toLocaleDateString("en-US", {
    timeZone: singaporeTimezone,
  });

  const [addTransactionPayload, setAddTransactionPayload] = useState({
    transaction_date: formatDate(currentDateInSingapore),
    transaction_amount: "",
    none_collection_days: "",
    loan_header_ref: "",
  });

  function formatDate(dateString) {
    const [month, day, year] = dateString.split("/");
    const formattedMonth = month.padStart(2, "0");
    const formattedDay = day.padStart(2, "0");
    return `${year}-${formattedMonth}-${formattedDay}`;
  }

  const [currentLoanHeader, setCurrentLoanHeader] = useState({});
  const [transactionSuccess, setTransactionSuccess] = useState(false);
  const [loanHeaderList, setLoanHeaderList] = useState([]);

  // filter options for autocomplete comp:
  const [managerNameList, setManagerNameList] = useState([]);
  const [agentNameList, setAgentNameList] = useState([]);
  const [nicknameList, setNicknameList] = useState([]);
  const [selectedCustomerNickname, setSelectedCustomerNickname] = useState("");
  const [loanClosureReason, setLoanClosureReason] = useState("");
  const [showCloseLoanHandler, setShowCloseLoanHandler] = useState("");
  const [customerSatisfactionReason, setCustomerSatisfactionReason] =
    useState("");

  const [nicknameForApi, setNicknameForApi] = useState("");
  const [agentNameForApi, setAgentNameForApi] = useState("");
  const [selectedAgentName, setSelectedAgentName] = useState("");
  const [managerNameForApi, setManagerNameForApi] = useState("");
  const [selectedManagerName, setSelectedManagerName] = useState("");
  // const [searchFilterOptionsShow, setSearchFilterOptionsShow] = useState(true);
  const searchFilterOptionsShowAgent = useRef(true);
  const searchFilterOptionsShowManager = useRef(true);
  const searchFilterOptionsShowNickname = useRef(true);
  const [reconciliationData, setReconciliationData] = useState([]);
  const [reconciliationDoneToday, setReconciliationDoneToday] = useState(false);

  const getAllManagerNames = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/manager_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      setManagerNameList(data);
    } else {
      setLoading(false);
    }
  };

  const getAllAgentNames = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/agent_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      setAgentNameList(data);
    } else {
      setLoading(false);
    }
  };

  const getAllCustomerList = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/customer/get_customer_nickname_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      // setCustomerHeadList(data)
      setNicknameList(data);
    } else {
      setLoading(false);
    }
  };

  const getLoanHeaderListAdmin = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/loan_header/loan_detail_admin?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];
    if (managerNameForApi) {
      queryParams.push(`manager_name=${managerNameForApi}`);
    }
    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (startBefore) {
      queryParams.push(`start_before=${startBefore}`);
    }

    if (startAfter) {
      queryParams.push(`start_after=${startAfter}`);
    }

    if (loanStatus) {
      queryParams.push(`loan_status=${loanStatus}`);
    }

    if (!loanStatus) {
      queryParams.push(`loan_status=Active`);
    }

    if (nicknameForApi) {
      queryParams.push(`nickname=${nicknameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);

    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      setLoanDetail(data);
      setCurrentData(data);
    }
  };

  const getLoanHeaderCountAdmin = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/loan_header/loan_detail_admin_count?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];
    if (managerNameForApi) {
      queryParams.push(`manager_name=${managerNameForApi}`);
    }
    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (startBefore) {
      queryParams.push(`start_before=${startBefore}`);
    }

    if (startAfter) {
      queryParams.push(`start_after=${startAfter}`);
    }

    if (loanStatus) {
      queryParams.push(`loan_status=${loanStatus}`);
    }

    if (!loanStatus) {
      queryParams.push(`loan_status=Active`);
    }

    if (nicknameForApi) {
      queryParams.push(`nickname=${nicknameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);

    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      setTotalPages(Math.ceil(data[0].totalCount / 20));
    }
  };

  const getLoanHeaderListManager = async () => {
    setLoading(true);

    let apiUrl = `${API_HOST}/api/loan_header/loan_detail_manager?page=${currentPage}&pageSize=${pageSize}`;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };
    const queryParams = [];
    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (startBefore) {
      queryParams.push(`start_before=${startBefore}`);
    }

    if (startAfter) {
      queryParams.push(`start_after=${startAfter}`);
    }

    if (loanStatus) {
      queryParams.push(`loan_status=${loanStatus}`);
    }

    if (!loanStatus) {
      queryParams.push(`loan_status=Active`);
    }

    if (nicknameForApi) {
      queryParams.push(`nickname=${nicknameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);

    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      setLoanDetail(data);
      setCurrentData(data);
    }
  };

  const getLoanHeaderListManagerCount = async () => {
    setLoading(true);

    let apiUrl = `${API_HOST}/api/loan_header/loan_detail_manager_count?page=${currentPage}&pageSize=${pageSize}`;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };
    const queryParams = [];
    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (startBefore) {
      queryParams.push(`start_before=${startBefore}`);
    }

    if (startAfter) {
      queryParams.push(`start_after=${startAfter}`);
    }

    if (loanStatus) {
      queryParams.push(`loan_status=${loanStatus}`);
    }

    if (!loanStatus) {
      queryParams.push(`loan_status=Active`);
    }

    if (nicknameForApi) {
      queryParams.push(`nickname=${nicknameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);

    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      setTotalPages(Math.ceil(data[0].totalCount / 20));
    }
  };

  const getLoanHeaderListAgent = async () => {
    setLoading(true);
    let apiUrl = `${API_HOST}/api/loan_header/loan_detail_agents?page=${currentPage}&pageSize=${pageSize}`;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };
    const queryParams = [];
    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (startBefore) {
      queryParams.push(`start_before=${startBefore}`);
    }

    if (startAfter) {
      queryParams.push(`start_after=${startAfter}`);
    }

    if (loanStatus) {
      queryParams.push(`loan_status=${loanStatus}`);
    }

    if (!loanStatus) {
      queryParams.push(`loan_status=Active`);
    }

    if (nicknameForApi) {
      queryParams.push(`nickname=${nicknameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);

    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      setLoanDetail(data);
      setCurrentData(data);
    }
  };

  const getLoanHeaderListAgentCount = async () => {
    setLoading(true);
    let apiUrl = `${API_HOST}/api/loan_header/loan_detail_agents_count?page=${currentPage}&pageSize=${pageSize}`;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };
    const queryParams = [];
    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (startBefore) {
      queryParams.push(`start_before=${startBefore}`);
    }

    if (startAfter) {
      queryParams.push(`start_after=${startAfter}`);
    }

    if (loanStatus) {
      queryParams.push(`loan_status=${loanStatus}`);
    }

    if (!loanStatus) {
      queryParams.push(`loan_status=Active`);
    }

    if (nicknameForApi) {
      queryParams.push(`nickname=${nicknameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);

    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      setTotalPages(Math.ceil(data[0].totalCount / 20));
    }
  };

  const getLoanOverViewAdmin = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/loan_header/get_loan_overview_admin`;

    const queryParams = [];
    if (managerNameForApi) {
      queryParams.push(`manager_name=${managerNameForApi}`);
    }
    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (nicknameForApi) {
      queryParams.push(`nickname=${nicknameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `?${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);

    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      setLoanOverViewByAdmin(data);
      console.log("dataType", typeof data);
    }
  };

  const getLoanOverViewManager = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/loan_header/get_loan_overview_manager`;

    const queryParams = [];

    if (agentNameForApi) {
      queryParams.push(`agent_name=${agentNameForApi}`);
    }

    if (nicknameForApi) {
      queryParams.push(`nickname=${nicknameForApi}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `?${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);

    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      setLoanOverViewByManager(data[0]);
      console.log("data", data);
      console.log("dataType", typeof data);
    }
  };

  const getLoanOverViewAgent = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };
    const { data } = await axios.get(
      `${API_HOST}/api/loan_header/get_loan_overview_agents`,
      config
    );

    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      setLoanOverViewByAgent(data[0]);
    }
  };

  const getCustomerListByAgent = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };
    const { data } = await axios.get(`${API_HOST}/api/customer/`, config);

    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      setCustomerListForAgent(data);
    }
  };

  const getCashReconciliationList = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/get_cash_plus?page=${currentPage}&pageSize=${pageSize}`;

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (data.message) {
        setLoading(false);
      } else {
        setLoading(false);
        // setManagerAgentCashReconciliationList(data);
        setReconciliationData(data);
      }
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userDataFromStorage.user_role === "admin") {
      getLoanHeaderListAdmin();
      getLoanHeaderCountAdmin();
    }

    if (
      userDataFromStorage.user_role === "agent" ||
      userDataFromStorage.user_role === "senior_agent"
    ) {
      getLoanHeaderListAgent();
      getLoanHeaderListAgentCount();
    }

    if (userDataFromStorage.user_role === "manager") {
      getLoanHeaderListManagerCount();
      getLoanHeaderListManager();
    }

    return () => {
      setTransactionSuccess(false);
    };
  }, [closeLoanSuccess, currentPage, transactionSuccess]);

  useEffect(() => {
    getAllManagerNames();
    getAllAgentNames();
    getAllCustomerList();

    if (
      userDataFromStorage.user_role === "agent" ||
      userDataFromStorage.user_role === "senior_agent"
    ) {
      getCustomerListByAgent();
      getCashReconciliationList();
    }
  }, []);

  useEffect(() => {
    if (userDataFromStorage.user_role === "admin") {
      getLoanOverViewAdmin();
    }
  }, [managerNameForApi, agentNameForApi, nicknameForApi]);

  useEffect(() => {
    if (userDataFromStorage.user_role === "manager") {
      getLoanOverViewManager();
    }
  }, [agentNameForApi, nicknameForApi]);

  useEffect(() => {
    if (
      userDataFromStorage.user_role === "agent" ||
      userDataFromStorage.user_role === "senior_agent"
    ) {
      getLoanOverViewAgent();
    }
  }, [nicknameForApi]);

  const closeLoanHandler = async (id_number) => {
    if (closeLoanReason) {
      setLoading(true);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage?.token}`,
        },
      };

      let payload = {
        reason: closeLoanReason,
      };

      const { data } = await axios.put(
        `${API_HOST}/api/loan_header/${selectedLoanToClose}`,
        payload,
        config
      );

      if (!data.message) {
        setLoading(false);
        toast.success(
          `Loan with Id ${selectedLoanToClose} Closed Successfully !!!`
        );
        setCloseLoanSuccess(true);
        setOpenLoanCloseReason(false);
      } else if (
        data.message === `Loan with id ${selectedLoanToClose} deleted.`
      ) {
        setLoading(false);
        toast.success(
          `Loan with Id ${selectedLoanToClose} Deleted Successfully !!!`
        );
        setCloseLoanSuccess(true);
        setOpenLoanCloseReason(false);
      }
    } else {
      toast.warn("Please provide a reason to close the loan");
    }
  };

  const getLoanHeaderList = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };
    const { data } = await axios.get(
      `${API_HOST}/api/loan_header/loan_detail_admin/${currentLoanCustomerData.id_number}`,
      config
    );

    if (data.message) {
      setLoading(false);
      toast.error(data.message);
    } else {
      setLoading(false);
      console.log("data", data[0]);
      setLoanHeaderList(data[0]);
    }
  };

  const loanDetailScreenDataHandler = async () => {
    setCurrentLoanOverViewLoading(true);
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    const payload = {
      loanId: currentLoanCustomerData.id_number,
    };

    const { data } = await axios.post(
      `${API_HOST}/api/transactions/loan_detail_transaction`,
      payload,
      config
    );

    if (data) {
      setCurrentLoanOverViewDetail(data);
      setCurrentLoanOverViewLoading(false);
    }

    console.log("data::::::::", data);
  };

  useEffect(() => {
    if (loanOverViewScreen === true) {
      loanDetailScreenDataHandler();
      getLoanHeaderList();
    }
  }, [currentLoanCustomerData]);

  useEffect(() => {
    if (currentLoanOverViewDetail) {
      const inputDate = new Date(currentLoanOverViewDetail?.start_date);

      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      console.log("input date", inputDate);

      const day = inputDate.getDate();
      console.log("day::::", day);
      const month = months[inputDate.getMonth()];
      const year = inputDate.getFullYear();

      const modifiedLastTransactionDate = `${day} ${month}, ${year}`;
      setLoanOverViewStartDate(modifiedLastTransactionDate);
    }
  }, [currentLoanOverViewDetail]);

  const addTransactionHandler = async () => {
    if (
      addTransactionPayload.transaction_amount &&
      addTransactionPayload.transaction_date
    ) {
      setLoading(true);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage?.token}`,
        },
      };

      const newPayload = {
        transaction_amount: parseInt(addTransactionPayload.transaction_amount),
        transaction_date: addTransactionPayload.transaction_date,
        loan_header_ref: currentLoanCustomerData.id_number,
      };
      const { data } = await axios.post(
        `${API_HOST}/api/transactions/add_transaction`,
        newPayload,
        config
      );

      if (data.message) {
        setLoading(false);
        toast.error(data.message);
      } else {
        setLoading(false);
        toast.success("New Transaction DEtails Added Successfully !!!");
        setNewTransactionModelOpen(false);
        setTransactionSuccess(true);
      }
    } else {
      toast.warn("Make Sure To Fill All Fields !!!");
    }
  };

  useEffect(() => {
    if (newTransactionModelOpen || openLoanCloseReason) {
      setLoanOverViewScreen(false);
    }
  }, [newTransactionModelOpen, openLoanCloseReason]);

  useEffect(() => {
    if (
      managerNameForApi ||
      agentNameForApi ||
      nicknameForApi ||
      startBefore ||
      startAfter ||
      loanStatus
    ) {
      console.log("agentNameForApi::::", agentNameForApi);
      if (userDataFromStorage.user_role === "admin") {
        console.log("agentNameForApi:::::::", agentNameForApi);
        getLoanHeaderListAdmin();
        getLoanHeaderCountAdmin();
      }

      if (
        userDataFromStorage.user_role === "agent" ||
        userDataFromStorage.user_role === "senior_agent"
      ) {
        getLoanHeaderListAgent();
      }

      if (userDataFromStorage.user_role === "manager") {
        getLoanHeaderListManager();
      }
    }
  }, [
    managerNameForApi,
    agentNameForApi,
    nicknameForApi,
    startAfter,
    startBefore,
    loanStatus,
  ]);

  const handleCustomerNicknameChange = useCallback((e) => {
    setNickname(e.target.value);
  }, []);

  const handleAgentNameChange = useCallback((e) => {
    setAgentLastName(e.target.value);
  }, []);

  const handleManagerNameChange = useCallback((e) => {
    setManagerLastName(e.target.value);
  }, []);

  const filteredNicknameOptions = useMemo(() => {
    if (nickname && !selectedCustomerNickname) {
      console.log("here");
      const searchTerm = nickname.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      nicknameList.forEach((option) => {
        if (
          option.nickname &&
          option.nickname.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.nickname.toLowerCase().startsWith(searchTerm)",
            option.nickname.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.nickname.localeCompare(b.nickname, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedCustomerNickname) {
        console.log("here agent1111");
        setNicknameForApi(selectedCustomerNickname);
        setSelectedCustomerNickname("");

        searchFilterOptionsShowNickname.current = false;
      } else {
        console.log("here agent222");
        searchFilterOptionsShowNickname.current = true;
      }

      return [];
    }
  }, [nickname, selectedCustomerNickname]);

  // let filteredAgentOptions = [];

  const filteredAgentOptions = useMemo(() => {
    if (agentLastName && !selectedAgentName) {
      console.log("here");
      const searchTerm = agentLastName.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      agentNameList.forEach((option) => {
        if (
          option.agent_name &&
          option.agent_name.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.agent_name.toLowerCase().startsWith(searchTerm)",
            option.agent_name.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.agent_name.localeCompare(b.agent_name, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedAgentName) {
        console.log("here agent1111");
        setAgentNameForApi(selectedAgentName);
        setSelectedAgentName("");

        searchFilterOptionsShowAgent.current = false;
      } else {
        console.log("here agent222");
        searchFilterOptionsShowAgent.current = true;
      }

      return [];
    }
  }, [agentLastName, selectedAgentName]);

  const filteredManagerOptions = useMemo(() => {
    if (managerLastName && !selectedManagerName) {
      console.log("here");
      const searchTerm = managerLastName.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      managerNameList.forEach((option) => {
        if (
          option.manager_name &&
          option.manager_name.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.manager_name.toLowerCase().startsWith(searchTerm)",
            option.manager_name.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.manager_name.localeCompare(b.manager_name, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedManagerName) {
        setManagerNameForApi(selectedManagerName);
        setSelectedManagerName("");

        searchFilterOptionsShowManager.current = false;
      } else {
        searchFilterOptionsShowManager.current = true;
      }

      return [];
    }
  }, [managerLastName, selectedManagerName]);

  // useEffect(() => {
  //   if (currentData.length && totalPages>0) {

  //     setTotalPages(Math.ceil(currentData.length / 20));

  //     // Calculate the index range for the current page
  //     const startIndex = (page - 1) * 20;
  //     const endIndex = startIndex + 20;

  //     // Slice the data array based on the current page
  //     const currentDataNew = currentData.slice(startIndex, endIndex);
  //     setFilteredData(currentDataNew);

  //   }
  // },[totalPages,page,currentData])

  function setToMidnight(date) {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
  }

  useEffect(() => {
    if (
      userDataFromStorage.user_role === "agent" ||
      userDataFromStorage.user_role === "senior_agent"
    ) {
      if (reconciliationData.length) {
        if (
          setToMidnight(reconciliationData[0].last_reconciliation).getTime() ===
          setToMidnight(new Date()).getTime()
        ) {
          setReconciliationDoneToday(true);
        }
      }
    }
  }, [reconciliationData]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[8rem] lg:px-[3rem] md:px-[2.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-sky-50  overflow-hidden"
          : "xl:px-[8rem] lg:px-[3rem] md:px-[2.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[4%]  mt-[20%] bg-sky-50 overflow-hidden"
      }>
      {userDataFromStorage.user_role === "admin" ? (
        <>
          <p className="text-gray-700 text-[1.8rem] tracking-wider">
            Admin Loan Filter
          </p>

          <div className="bg-white md:text-[0.75rem] lg:text-[1rem]">
            <p
              style={{ backgroundColor: coloredTheme }}
              className=" text-white px-[0.5rem] py-[1rem] mt-6">
              Open Loans Overview
            </p>
            <div className="md:px-[0.5rem] px-[0.7rem]">
              <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
                <div
                  style={{ borderRight: `2rem solid ${coloredTheme}` }}
                  className="md:flex justify-between md:w-[50%] items-center hidden md:border-r-[2rem] h-[100%] ">
                  <p>Number of Loans</p>
                  <p className="md:w-[50%] text-center">
                    {loanOverViewByAdmin
                      ? loanOverViewByAdmin[0]?.number_of_loans?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
                {/* for mobile */}
                <div className="md:hidden flex justify-between items-center">
                  <p>Number of Loans</p>
                  <p className="">
                    {loanOverViewByAdmin
                      ? loanOverViewByAdmin[0]?.number_of_loans?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
                <div className="flex justify-between mt-1 md:mt-0 md:w-[50%] md:pl-[0.5rem] items-center  md:h-[100%] ">
                  <p>Total Amount Remaining</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {loanOverViewByAdmin
                      ? loanOverViewByAdmin[0]?.total_amount_remaining?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
              </div>
              <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
                <div
                  style={{ borderRight: `2rem solid ${coloredTheme}` }}
                  className="md:flex hidden justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%] ">
                  <p>Total Loan Amount</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {loanOverViewByAdmin
                      ? loanOverViewByAdmin[0]?.total_loan_amount?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
                {/* for mobile */}
                <div className="flex justify-between  items-center  md:hidden mt-1 ">
                  <p>Total Loan Amount</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {loanOverViewByAdmin
                      ? loanOverViewByAdmin[0]?.total_loan_amount?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
                <div className="flex md:pl-[0.5rem] justify-between md:w-[50%] items-center mt-1 md:mt-0 md:h-[100%]  ">
                  <p>Maximum Amount Remaining</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {loanOverViewByAdmin
                      ? loanOverViewByAdmin[0]?.max_amount_remaining?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
              </div>
              <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
                <div
                  style={{ borderRight: `2rem solid ${coloredTheme}` }}
                  className="md:flex hidden justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  ">
                  <p>Average Loan Amount</p>
                  <p className="md:w-[50%] text-center">
                    {/* MYR{" "}
                    {loanOverViewByAdmin
                      ? loanOverViewByAdmin.average_loan_amount
                      : "---"} */}
                    "---"
                  </p>
                </div>
                <div className="flex justify-between md:hidden items-center  ">
                  <p>Average Loan Amount</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {/* {loanOverViewByAdmin
                      ? loanOverViewByAdmin.average_loan_amount
                      : "---"} */}
                    "---"
                  </p>
                </div>
                <div className="flex justify-between mt-1 md:mt-0 md:w-[50%] items-center   md:h-[100%] md:pl-[0.5rem]">
                  <p>Average Amount Remaining</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {/* {loanOverViewByAdmin
                      ? loanOverViewByAdmin.average_amount_remaining
                      : "---"} */}
                    "---"
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 bg-white py-[1rem] px-[0.5rem] md:text-[0.75rem] lg:text-[1rem]">
            <div className="relative md:flex justify-start items-center mt-6">
              <p className="w-[30%]">Manager Last Name</p>
              <input
                type="text"
                value={managerLastName}
                placeholder="Enter Manager Last Name"
                onInput={(e) => {
                  console.log("e.target::::::", e.target.value);
                  handleManagerNameChange(e);
                }}
                className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
              />
              {filteredManagerOptions.length > 0 && (
                <div
                  className={
                    searchFilterOptionsShowManager?.current
                      ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                      : "hidden"
                  }>
                  {filteredManagerOptions.map((option, index) => (
                    <div
                      className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                      onClick={() => {
                        setSelectedManagerName(option.manager_name);
                        setManagerLastName(option.manager_name);
                      }}
                      key={index}>
                      {option.manager_name}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="relative md:flex justify-start items-center mt-6">
              <p className="w-[30%]">Agent Last Name</p>
              <input
                type="text"
                value={agentLastName}
                placeholder="Enter Agent Last Name"
                onInput={(e) => {
                  console.log("e.target::::::", e.target.value);
                  handleAgentNameChange(e);
                }}
                className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
              />
              {filteredAgentOptions.length > 0 && (
                <div
                  className={
                    searchFilterOptionsShowAgent.current === true
                      ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                      : "hidden"
                  }>
                  {filteredAgentOptions.map((option, index) => (
                    <div
                      className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                      onClick={() => {
                        console.log("option.agent_name::", option.agent_name);
                        setAgentLastName(option.agent_name);
                        setSelectedAgentName(option.agent_name);
                      }}
                      key={index}>
                      {option.agent_name}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="relative md:flex justify-start items-center mt-6">
              <p className="w-[30%]">Customer Nickname</p>
              <input
                type="text"
                value={nickname}
                placeholder="Enter Customer Nickname"
                onInput={(e) => {
                  console.log("e.target::::::", e.target.value);
                  handleCustomerNicknameChange(e);
                }}
                className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
              />
              {filteredNicknameOptions.length > 0 && (
                <div
                  className={
                    searchFilterOptionsShowNickname.current
                      ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                      : "hidden"
                  }>
                  {filteredNicknameOptions.map((option, index) => (
                    <div
                      className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                      onClick={() => {
                        setSelectedCustomerNickname(option.nickname);
                        setNickname(option.nickname);
                      }}
                      key={index}>
                      {option.nickname}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="md:flex justify-start items-center mt-6">
              <p className="w-[25rem]">Loan Started After</p>
              <input
                type="date"
                value={startAfter}
                onChange={(e) => setStartAfter(e.target.value)}
                className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
              />
            </div>
            <div className="md:flex justify-start items-center mt-6">
              <p className="w-[25rem]">Loan Started Before</p>
              <input
                type="date"
                value={startBefore}
                onChange={(e) => setStartBefore(e.target.value)}
                className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
              />
            </div>
            <div className="md:flex justify-start items-center mt-6">
              <p className="md:w-[25rem]">Loan Status</p>
              <div className="flex items-center">
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={loanStatus}
                    name="radio-buttons-group"
                    onChange={(e) => setLoanStatus(e.target.value)}
                    row>
                    <FormControlLabel
                      value={"Active"}
                      control={<Radio />}
                      label="Active"
                    />
                    <FormControlLabel
                      value={"Closed"}
                      control={<Radio />}
                      label="Closed"
                    />
                    <FormControlLabel
                      value={"All"}
                      control={<Radio />}
                      label="All"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
            <div className="flex justify-start items-center space-x-4">
              <button
                onClick={() => {
                  setNickname("");
                  setAgentLastName("");
                  setManagerLastName("");
                  setStartAfter("");
                  setStartBefore("");
                  setAgentNameForApi("");
                  setManagerNameForApi("");
                  setNicknameForApi("");
                }}
                style={{ backgroundColor: coloredTheme }}
                className="flex justify-center items-center mt-6 rounded space-x-2 transition duration-[0.6s] px-[1rem] py-[0.5rem] text-white">
                <FaUndo />
                <p>reset</p>
              </button>
              <button
                onClick={() => getLoanHeaderListAdmin()}
                style={{ backgroundColor: coloredTheme }}
                className="flex justify-center items-center mt-6 rounded space-x-2 transition duration-[0.6s] px-[1rem] py-[0.5rem] text-white">
                <FiSearch />
                <p>Search</p>
              </button>
            </div>
          </div>
        </>
      ) : userDataFromStorage.user_role === "manager" ? (
        <>
          <p className="text-gray-700  text-[1.8rem] tracking-wider">
            Loan Overview
          </p>
          <p className="text-gray-600 mt-2 text-[0.8rem] tracking-wider">
            Details on loans are shown below
          </p>

          <div className="bg-white md:text-[0.75rem] lg:text-[1rem]">
            <p
              style={{ backgroundColor: coloredTheme }}
              className="change-bg text-white px-[0.5rem] py-[1rem] mt-6">
              Open Loans Overview
            </p>
            <div className="md:px-[0.5rem] px-[0.7rem]">
              <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
                <div className="flex justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  border-[#f9ddc2]">
                  <p>Number of Loans</p>
                  <p className="md:w-[50%] text-center">
                    {loanOverViewByManager
                      ? loanOverViewByManager?.number_of_loans?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
                <div className="flex justify-between md:w-[50%] md:pl-[0.5rem] items-center  h-[100%] ">
                  <p>Total Amount Remaining</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {loanOverViewByManager
                      ? loanOverViewByManager?.total_amount_remaining?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
              </div>
              <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
                <div className="flex justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  border-[#f9ddc2]">
                  <p>Total Loan Amount</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {loanOverViewByManager
                      ? loanOverViewByManager?.total_loan_amount?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
                <div className="flex md:pl-[0.5rem] justify-between md:w-[50%] items-center   h-[100%]  ">
                  <p>Maximum Amount Remaining</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {loanOverViewByManager
                      ? loanOverViewByManager?.max_amount_remaining?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
              </div>
              <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
                <div className="flex justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  border-[#f9ddc2]">
                  <p>Average Loan Amount</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {loanOverViewByManager
                      ? loanOverViewByManager?.average_loan_amount?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
                <div className="flex justify-between md:w-[50%] items-center   h-[100%] md:pl-[0.5rem]">
                  <p>Average Amount Remaining</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {loanOverViewByManager
                      ? loanOverViewByManager?.average_amount_remaining?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 bg-white py-[1rem] px-[0.5rem] md:text-[0.75rem] lg:text-[1rem]">
            <div className="relative md:flex justify-start items-center mt-6">
              <p className="w-[30%]">Agent Last Name</p>
              <input
                type="text"
                value={agentLastName}
                placeholder="Enter Agent Last Name"
                onInput={(e) => {
                  console.log("e.target::::::", e.target.value);
                  handleAgentNameChange(e);
                }}
                className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
              />
              {filteredAgentOptions.length > 0 && (
                <div
                  className={
                    searchFilterOptionsShowAgent?.current
                      ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                      : "hidden"
                  }>
                  {filteredAgentOptions.map((option, index) => (
                    <div
                      className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                      onClick={() => {
                        console.log("option.agent_name::", option.agent_name);
                        setAgentLastName(option.agent_name);
                        setSelectedAgentName(option.agent_name);
                      }}
                      key={index}>
                      {option.agent_name}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* <div>
              <p className="w-[25rem]">Customer Nickname</p>
              <Autocomplete
                onChange={(event, newValue) => {
                  setNickname(newValue.nickname);
                }}
                value={
                  nicknameList.find((option) => option.nickname === nickname) ||
                  null
                }
                className="outline-none  rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
                options={nicknameList}
                getOptionLabel={(option) => option.nickname}
                renderInput={(params) => (
                  <TextField {...params} label="Customer Nickname" />
                )}
              />
            </div> */}
            <div className="relative md:flex justify-start items-center mt-6">
              <p className="w-[30%]">Customer Nickname</p>
              <input
                type="text"
                value={nickname}
                placeholder="Enter Customer Nickname"
                onInput={(e) => {
                  console.log("e.target::::::", e.target.value);
                  handleCustomerNicknameChange(e);
                }}
                className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
              />
              {filteredNicknameOptions.length > 0 && (
                <div
                  className={
                    searchFilterOptionsShowNickname.current
                      ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                      : "hidden"
                  }>
                  {filteredNicknameOptions.map((option, index) => (
                    <div
                      className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                      onClick={() => {
                        setSelectedCustomerNickname(option.nickname);
                        setNickname(option.nickname);
                      }}
                      key={index}>
                      {option.nickname}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="md:flex justify-start items-center mt-6">
              <p className="w-[25rem]">Loan Started After</p>
              <input
                value={startAfter}
                onChange={(e) => setStartAfter(e.target.value)}
                type="date"
                className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
              />
            </div>
            <div className="md:flex justify-start items-center mt-6">
              <p className="w-[25rem]">Loan Started Before</p>
              <input
                value={startBefore}
                onChange={(e) => setStartBefore(e.target.value)}
                type="date"
                className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
              />
            </div>
            <div className="flex justify-start items-center mt-6">
              <p className="w-[25rem]">Loan Status</p>
              <div className="flex items-center ">
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={loanStatus}
                    name="radio-buttons-group"
                    onChange={(e) => setLoanStatus(e.target.value)}
                    row>
                    <FormControlLabel
                      value={"Active"}
                      control={<Radio />}
                      label="Active"
                    />
                    <FormControlLabel
                      value={"Closed"}
                      control={<Radio />}
                      label="Closed"
                    />
                    <FormControlLabel
                      value={"All"}
                      control={<Radio />}
                      label="All"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
            <div className="flex justify-start items-center space-x-4 mt-8 mb-4">
              <button
                onClick={() => {
                  setNickname("");
                  setAgentLastName("");
                  setManagerLastName("");
                  setStartAfter("");
                  setStartBefore("");
                  setAgentNameForApi("");
                  setManagerNameForApi("");
                  setNicknameForApi("");
                }}
                style={{ backgroundColor: coloredTheme }}
                className="flex justify-center items-center  rounded space-x-2 transition duration-[0.6s] px-[1rem] py-[0.5rem] text-white">
                <FaUndo />
                <p>reset</p>
              </button>
              <button
                onClick={() => getLoanHeaderListManager()}
                style={{ backgroundColor: coloredTheme }}
                className="flex justify-center items-center space-x-2 text-white px-[1rem] py-[0.5rem] rounded transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                <CiSearch />
                <p>Search</p>
              </button>
            </div>
          </div>
        </>
      ) : (
        <>
          <p className="text-gray-700  text-[1.8rem] tracking-wider">
            Loan Overview
          </p>
          <p className="text-gray-600 mt-2 text-[0.8rem] tracking-wider">
            Details on loans are shown below
          </p>

          <div className="bg-white md:text-[0.75rem] lg:text-[1rem]">
            <p
              style={{ backgroundColor: coloredTheme }}
              className="change-bg text-white px-[0.5rem] py-[1rem] mt-6">
              Open Loans Overview
            </p>
            <div className="md:px-[0.5rem] px-[0.7rem]">
              <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
                <div className="flex justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  border-[#f9ddc2]">
                  <p>Number of Loans</p>
                  <p className="md:w-[50%] text-center">
                    {loanOverViewByAgent
                      ? loanOverViewByAgent?.number_of_loans?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
                <div className="flex justify-between md:w-[50%] md:pl-[0.5rem] items-center  h-[100%] ">
                  <p>Total Amount Remaining</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {loanOverViewByAgent
                      ? loanOverViewByAgent?.total_amount_remaining?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
              </div>
              <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
                <div className="flex justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  border-[#f9ddc2]">
                  <p>Total Loan Amount</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {loanOverViewByAgent
                      ? loanOverViewByAgent?.total_loan_amount?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
                <div className="flex md:pl-[0.5rem] justify-between md:w-[50%] items-center   h-[100%]  ">
                  <p>Maximum Amount Remaining</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {loanOverViewByAgent
                      ? loanOverViewByAgent?.max_amount_remaining?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
              </div>
              <div className="md:flex justify-start items-center border-b md:h-[4rem] mt-2 md:mt-0">
                <div className="flex justify-between md:w-[50%] items-center  md:border-r-[2rem] h-[100%]  border-[#f9ddc2]">
                  <p>Average Loan Amount</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {loanOverViewByAgent
                      ? loanOverViewByAgent?.average_loan_amount?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
                <div className="flex justify-between md:w-[50%] items-center   h-[100%] md:pl-[0.5rem]">
                  <p>Average Amount Remaining</p>
                  <p className="md:w-[50%] text-center">
                    MYR{" "}
                    {loanOverViewByAgent
                      ? loanOverViewByAgent?.average_amount_remaining?.toLocaleString(
                          "en-US"
                        )
                      : "---"}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 bg-white py-[1rem] px-[0.5rem] md:text-[0.75rem] lg:text-[1rem]">
            {/* <div className='md:flex justify-start items-center mt-6'>
                  <p className='w-[25rem]'>Agent Last Name</p>
                  <input type="text" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
                </div> */}
            <div className="relative md:flex justify-start items-center mt-6">
              <p className="w-[30%]">Customer Nickname</p>
              <input
                type="text"
                value={nickname}
                placeholder="Enter Customer Nickname"
                onInput={(e) => {
                  console.log("e.target::::::", e.target.value);
                  handleCustomerNicknameChange(e);
                }}
                className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
              />
              {filteredNicknameOptions.length > 0 && (
                <div
                  className={
                    searchFilterOptionsShowNickname.current
                      ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                      : "hidden"
                  }>
                  {filteredNicknameOptions.map((option, index) => (
                    <div
                      className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                      onClick={() => {
                        setSelectedCustomerNickname(option.nickname);
                        setNickname(option.nickname);
                      }}
                      key={index}>
                      {option.nickname}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="md:flex justify-start items-center mt-6">
              <p className="w-[25rem]">Loan Started After</p>
              <input
                value={startAfter}
                onChange={(e) => setStartAfter(e.target.value)}
                type="date"
                className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
              />
            </div>
            <div className="md:flex justify-start items-center mt-6">
              <p className="w-[25rem]">Loan Started Before</p>
              <input
                value={startBefore}
                onChange={(e) => setStartBefore(e.target.value)}
                type="date"
                className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
              />
            </div>
            <div className="flex justify-start items-center mt-6">
              <p className="w-[25rem]">Loan Status</p>
              <div className="flex items-center ">
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={loanStatus}
                    name="radio-buttons-group"
                    onChange={(e) => setLoanStatus(e.target.value)}
                    row>
                    <FormControlLabel
                      value={"Active"}
                      control={<Radio />}
                      label="Active"
                    />
                    <FormControlLabel
                      value={"Closed"}
                      control={<Radio />}
                      label="Closed"
                    />
                    <FormControlLabel
                      value={"All"}
                      control={<Radio />}
                      label="All"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
            <div className="flex justify-start items-center space-x-4 mt-8 mb-4">
              <button
                onClick={() => {
                  setNickname("");
                  setAgentLastName("");
                  setManagerLastName("");
                  setStartAfter("");
                  setStartBefore("");
                  setAgentNameForApi("");
                  setManagerNameForApi("");
                  setNicknameForApi("");
                }}
                style={{ backgroundColor: coloredTheme }}
                className="flex justify-center items-center  rounded space-x-2 transition duration-[0.6s] px-[1rem] py-[0.5rem] text-white">
                <FaUndo />
                <p>reset</p>
              </button>
              <button
                onClick={() => getLoanHeaderListAgent()}
                style={{ backgroundColor: coloredTheme }}
                className="flex justify-center items-center space-x-2 text-white px-[1rem] py-[0.5rem] rounded transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                <CiSearch />
                <p>Search</p>
              </button>
            </div>
          </div>
        </>
      )}

      {userDataFromStorage.user_role === "admin" ? (
        <div className="mt-8 bg-white pb-[1.5rem]">
          <p
            style={{ backgroundColor: coloredTheme }}
            className="change-bg p-[1rem] md:w-[100%]  text-white">
            Loans
          </p>
          <div className="p-[0.5rem]">
            <button
              style={{ backgroundColor: coloredTheme }}
              className="px-[2rem] rounded-lg  text-white space-x-2 py-[0.5rem] border flex justify-center items-center change-bg  hover:font-[600] hover:bg-green-50 hover:shadow-2xl hover:shadow-black transition duration-[0.6s]">
              <RiFileExcel2Fill className="text-xl" />
              <span>Export Loans Data to Excel</span>
            </button>
          </div>

          <div className="overflow-scroll px-[0.5rem] text-[0.9rem]">
            <table className="md:w-[100%] text-[0.7rem] xl:w-[100%] w-[350%] ">
              <thead className="h-[6vh]">
                <tr className="border border-gray-400">
                  <th className="text-center  border-r border-gray-400 px-[0.2rem]">
                    Manager Name
                  </th>
                  <th className="text-center  border-r border-gray-400 px-[0.2rem]">
                    Agent Name
                  </th>
                  <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                    Customer Nickname
                  </th>
                  <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                    Loan Number
                  </th>
                  <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                    Product code
                  </th>
                  <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                    Cash Disbursed
                  </th>
                  <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                    Loan Amount
                  </th>
                  <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                    Loan Status
                  </th>
                  <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                    Amount Remaining
                  </th>
                  <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                    {"Loan Days/Payments Remaining".slice(0, 25)}...
                  </th>
                  <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                    Last Transaction
                  </th>
                  <th className="text-center border-r  border-gray-400 px-[0.2rem]"></th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Extra Payment
                  </th>
                  <th className="text-center   px-[0.2rem]"></th>
                </tr>
              </thead>
              <tbody>
                {currentData.length
                  ? currentData.map((x, index) => {
                      let date = new Date(x?.last_transaction_date);
                      let day = String(date?.getUTCDate()).padStart(2, "0");
                      let month = String(date?.getUTCMonth() + 1).padStart(
                        2,
                        "0"
                      );
                      let year = String(date?.getUTCFullYear());
                      let modifiedLastTransactionDate = `${day}-${month}-${year}`;

                      let date1 = new Date(x?.cash_disbursed_date);
                      let day1 = String(date1?.getUTCDate()).padStart(2, "0");
                      let month1 = String(date1?.getUTCMonth() + 1).padStart(
                        2,
                        "0"
                      );
                      let year1 = String(date1?.getUTCFullYear());
                      let modifiedCashDisbursed = `${day1}-${month1}-${year1}`;
                      return (
                        <tr
                          onClick={() => {
                            setLoanOverViewScreen(true);
                            setCurrentLoanCustomerData(x);
                          }}
                          className="border border-gray-400 hover:bg-cyan-100 transition duration-[0.3s] cursor-pointer">
                          <td className="text-center border-l border-t border-r border-gray-400 px-[0.2rem]">
                            {x.managerName}
                          </td>
                          <td className="text-center border-l border-t border-r border-gray-400 px-[0.2rem]">
                            {x.agentName}
                          </td>
                          <td className="text-center border-l border-t border-r border-gray-400 px-[0.2rem]">
                            {x.customer_nickname}
                          </td>
                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem] ">
                            <span className="block">
                              {" "}
                              {`Company Loan Number : ${x.loan_number}`}
                            </span>
                            <span>
                              {" "}
                              {x.agent_loan
                                ? `Agent Loan Number : ${x.agent_loan}`
                                : `Agent Loan Number : 0`}
                            </span>
                          </td>
                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem]">
                            {x.product_code}
                          </td>
                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem]">
                            {modifiedCashDisbursed}
                          </td>
                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem]">
                            MYR {x.amount}
                          </td>
                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem]">
                            {x.status}
                          </td>
                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem]">
                            MYR {x.amount_remaining}
                          </td>
                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem]">
                            {" "}
                            {x.number_of_payments_remaining}
                          </td>
                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem]">
                            {modifiedLastTransactionDate
                              ? modifiedLastTransactionDate
                              : "---"}
                          </td>

                          {x.last_transaction_date ? (
                            <td className="text-center border-t border-r border-gray-400 px-[0.2rem]">
                              <button>Review Payments</button>
                            </td>
                          ) : (
                            <td className="text-center border-t border-r border-gray-400 px-[0.2rem]">
                              No Payments Collected
                            </td>
                          )}
                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem]">
                            {userDataFromStorage.user_role === "admin" ||
                            userDataFromStorage.user_role === "manager"
                              ? x?.extra_payment
                              : ""}
                          </td>
                          <td
                            className={
                              index === 0
                                ? "flex justify-center items-center space-x-4 py-[0.5rem]  px-[0.2rem]"
                                : index === currentData.length - 1
                                ? "flex  justify-center items-center space-x-4 py-[0.5rem]     px-[0.2rem]"
                                : "flex  justify-center items-center space-x-4 py-[0.5rem]  px-[0.2rem]"
                            }>
                            <button
                              style={{ backgroundColor: coloredTheme }}
                              onClick={() =>
                                navigate(
                                  `/transaction/list?loanHeader=${x.id_number}`
                                )
                              }
                              className="flex justify-center items-center space-x-2 text-white  px-[1rem] py-[0.5rem] rounded  hover:shadow-2xl hover:shadow-black">
                              <CiSearch className="hidden md:block" />
                              <span>Transaction List</span>
                            </button>
                            {/* manager/admin access to close a loan */}

                            {userDataFromStorage.user_role === "admin" ||
                            userDataFromStorage.user_role === "manager" ? (
                              <button
                                onClick={() => {
                                  setSelectedCloseToClose(x.id_number);

                                  setOpenLoanCloseReason(true);
                                  setCurrentLoanCustomerData(x);
                                }}
                                className="flex justify-center items-center space-x-2 bg-red-400 text-red-50 px-[1rem] py-[0.5rem] rounded hover:text-red-500 hover:bg-red-50  hover:shadow-2xl hover:shadow-black">
                                <MdDeleteForever className="hidden md:block" />
                                <span>Close Loan</span>
                              </button>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      );
                    })
                  : ""}
              </tbody>
            </table>
          </div>
          {/* PAGINATION */}
          <div className=" flex justify-end items-center mt-[2%] px-[0.8rem]">
            <Stack spacing={2}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(event, newPage) => setCurrentPage(newPage)}
                variant="outlined"
                shape="rounded"
              />
            </Stack>
          </div>
        </div>
      ) : userDataFromStorage.user_role === "manager" ? (
        <div className="mt-8 bg-white pb-[1.5rem]">
          <p
            style={{ backgroundColor: coloredTheme }}
            className="change-bg p-[1rem] md:w-[100%]  text-white">
            Loans
          </p>
          <div className="p-[0.5rem]">
            <button
              style={{ backgroundColor: coloredTheme }}
              className="px-[2rem] rounded-lg  text-white space-x-2 py-[0.5rem] border flex justify-center items-center change-bg  hover:font-[600] hover:bg-green-50 hover:shadow-2xl hover:shadow-black transition duration-[0.6s]">
              <RiFileExcel2Fill className="text-xl" />
              <span>Export Loans Data to Excel</span>
            </button>
          </div>

          <div className="overflow-scroll lg:overflow-hidden px-[0.5rem]">
            <table className="md:w-[100%] xl:w-[100%] w-[350%] lg:w-[100%] ">
              <thead className="h-[6vh] lg:text-[0.9rem] xl:text-[1rem]">
                <tr className="border border-gray-400">
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Agent Name
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Customer Nickname
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Loan Number
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Product code
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Cash Disbursed
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Loan Amount
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Amount Remaining
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    {"Loan Days/Payments Remaining".slice(0, 25)}...
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Last Transaction
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Extra Payment
                  </th>
                  <th
                    className={
                      userDataFromStorage.user_role === "admin"
                        ? "text-start border-r  border-gray-400 px-[0.2rem]"
                        : "text-start  px-[0.2rem]"
                    }></th>

                  <th className="text-start   px-[0.2rem]"></th>
                </tr>
              </thead>
              <tbody>
                {currentData.length
                  ? currentData.map((x, index) => {
                      let date = new Date(x?.last_transaction_date);
                      let day = String(date?.getUTCDate()).padStart(2, "0");
                      let month = String(date?.getUTCMonth() + 1).padStart(
                        2,
                        "0"
                      );
                      let year = String(date?.getUTCFullYear());
                      let modifiedLastTransactionDate = `${day}-${month}-${year}`;

                      let date1 = new Date(x?.cash_disbursed_date);
                      let day1 = String(date1?.getUTCDate()).padStart(2, "0");
                      let month1 = String(date1?.getUTCMonth() + 1).padStart(
                        2,
                        "0"
                      );
                      let year1 = String(date1?.getUTCFullYear());
                      let modifiedCashDisbursed = `${day1}-${month1}-${year1}`;
                      return (
                        <tr
                          onClick={() => {
                            setLoanOverViewScreen(true);
                            setCurrentLoanCustomerData(x);
                          }}
                          className="border border-gray-400 hover:bg-cyan-100 transition duration-[0.3s] cursor-pointer lg:text-[0.8rem] xl:text-[1rem]">
                          <td className="text-start border-l border-t border-r border-gray-400 px-[0.2rem]">
                            {x.agentName}
                          </td>
                          <td className="text-start border-l border-t border-r border-gray-400 px-[0.2rem]">
                            {x.customer_nickname}
                          </td>
                          <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                            {x.agent_loan ? x.agent_loan : "0"}
                          </td>
                          <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                            {x.product_code}
                          </td>
                          <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                            {modifiedCashDisbursed}
                          </td>
                          <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                            MYR {x.amount}
                          </td>
                          <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                            MYR {x.amount_remaining}
                          </td>
                          <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                            {" "}
                            {x.number_of_payments_remaining}
                          </td>
                          <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                            {modifiedLastTransactionDate
                              ? modifiedLastTransactionDate
                              : "---"}
                          </td>
                          <td className="text-center border-t border-r border-gray-400 px-[0.2rem]">
                            {x.extra_payment}
                          </td>

                          {/* {x.last_transaction_date ? (
                            <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                              <button>Review Payments</button>
                            </td>
                          ) : (
                            <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                              No Payments Collected
                            </td>
                          )} */}
                          <td
                            className={
                              index === 0
                                ? "flex justify-center items-center space-x-4 py-[0.5rem]  px-[0.2rem]"
                                : index === currentData.length - 1
                                ? "flex  justify-center items-center space-x-4 py-[0.5rem]     px-[0.2rem]"
                                : "flex  justify-center items-center space-x-4 py-[0.5rem]  px-[0.2rem]"
                            }>
                            <button
                              style={{ backgroundColor: coloredTheme }}
                              onClick={() =>
                                navigate(
                                  `/transaction/list?loanHeader=${x.id_number}`
                                )
                              }
                              className="flex justify-center items-center space-x-2 text-white  px-[1rem] py-[0.5rem] rounded  hover:shadow-2xl hover:shadow-black">
                              <CiSearch />
                              <span>Transaction List</span>
                            </button>
                            {/* manager/admin access to close a loan */}

                            {userDataFromStorage.user_role === "admin" ||
                            userDataFromStorage.user_role === "manager" ? (
                              <button
                                onClick={() => {
                                  setSelectedCloseToClose(x.id_number);
                                  setOpenLoanCloseReason(true);
                                  setCurrentLoanCustomerData(x);
                                }}
                                className="flex justify-center items-center space-x-2 bg-red-400 text-red-50 px-[1rem] py-[0.5rem] rounded hover:text-red-500 hover:bg-red-50  hover:shadow-2xl hover:shadow-black">
                                <MdDeleteForever />
                                <span>Close Loan</span>
                              </button>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      );
                    })
                  : ""}
              </tbody>
            </table>
          </div>
          {/* PAGINATION */}
          <div className=" flex justify-end items-center mt-[2%] px-[0.8rem]">
            <Stack spacing={2}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(event, newPage) => setCurrentPage(newPage)}
                variant="outlined"
                shape="rounded"
              />
            </Stack>
          </div>
        </div>
      ) : userDataFromStorage.user_role === "agent" ||
        userDataFromStorage.user_role === "senior_agent" ? (
        <div className="mt-8 bg-white pb-[1.5rem]">
          <p
            style={{ backgroundColor: coloredTheme }}
            className="change-bg p-[1rem] md:w-[100%]  text-white">
            Loans
          </p>
          <div className="p-[0.5rem]">
            <button
              style={{ backgroundColor: coloredTheme }}
              className="px-[2rem] rounded-lg  text-white space-x-2 py-[0.5rem] border flex justify-center items-center change-bg  hover:font-[600] hover:bg-green-50 hover:shadow-2xl hover:shadow-black transition duration-[0.6s]">
              <RiFileExcel2Fill className="text-xl" />
              <span>Export Loans Data to Excel</span>
            </button>
          </div>

          <div className="overflow-scroll px-[0.5rem]">
            <table className="md:w-[100%] xl:w-[100%] w-[350%] ">
              <thead className="h-[6vh]">
                <tr className="border border-gray-400">
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Customer Nickname
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Loan Number
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Product code
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Cash Disbursed
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Loan Amount
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Amount Remaining
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    {"Loan Days/Payments Remaining".slice(0, 25)}...
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Last Transaction
                  </th>
                  <th className="text-start border-r  border-gray-400 px-[0.2rem]">
                    Extra Payment
                  </th>
                  <th className="text-start  px-[0.2rem]"></th>
                </tr>
              </thead>
              <tbody>
                {currentData.length
                  ? currentData.map((x, index) => {
                      let date = new Date(x?.last_transaction_date);
                      let day = String(date?.getUTCDate()).padStart(2, "0");
                      let month = String(date?.getUTCMonth() + 1).padStart(
                        2,
                        "0"
                      );
                      let year = String(date?.getUTCFullYear());
                      let modifiedLastTransactionDate = `${day}-${month}-${year}`;

                      let date1 = new Date(x?.cash_disbursed_date);
                      let day1 = String(date1?.getUTCDate()).padStart(2, "0");
                      let month1 = String(date1?.getUTCMonth() + 1).padStart(
                        2,
                        "0"
                      );
                      let year1 = String(date1?.getUTCFullYear());
                      let modifiedCashDisbursed = `${day1}-${month1}-${year1}`;

                      return (
                        <tr
                          onClick={() => {
                            setLoanOverViewScreen(true);
                            setCurrentLoanCustomerData(x);
                          }}
                          className="border border-gray-400 hover:bg-cyan-100 trannsition duration-[0.3s] cursor-pointer">
                          <td className="text-start border-l border-t border-r border-gray-400 px-[0.2rem]">
                            {x.customer_nickname}
                          </td>
                          <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                            {x.agent_loan ? x.agent_loan : "0"}
                          </td>
                          <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                            {x.product_code}
                          </td>
                          <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                            {modifiedCashDisbursed}
                          </td>
                          <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                            MYR {x.amount}
                          </td>
                          <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                            {x.amount_remaining}
                          </td>
                          <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                            {" "}
                            {x.number_of_payments_remaining}
                          </td>
                          <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                            {modifiedLastTransactionDate
                              ? modifiedLastTransactionDate
                              : "---"}
                          </td>
                          <td className="text-start border-t border-r border-gray-400 px-[0.2rem]">
                            {x.extra_payment}
                          </td>

                          <td
                            className={
                              index === 0
                                ? "flex justify-center items-center space-x-4 py-[0.5rem]  px-[0.2rem]"
                                : index === currentData.length - 1
                                ? "flex  justify-center items-center space-x-4 py-[0.5rem]     px-[0.2rem]"
                                : "flex  justify-center items-center space-x-4 py-[0.5rem]  px-[0.2rem]"
                            }>
                            <button
                              style={{ backgroundColor: coloredTheme }}
                              onClick={() =>
                                navigate(
                                  `/transaction/list?loanHeader=${x.id_number}`
                                )
                              }
                              className="flex justify-center items-center space-x-2 text-white  px-[1rem] py-[0.5rem] rounded  hover:shadow-2xl hover:shadow-black">
                              <CiSearch className="hidden md:block" />
                              <span>Transaction List</span>
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  : ""}
              </tbody>
            </table>
          </div>
          {/* PAGINATION */}
          <div className=" flex justify-end items-center mt-[2%] px-[0.8rem]">
            <Stack spacing={2}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(event, newPage) => setCurrentPage(newPage)}
                variant="outlined"
                shape="rounded"
              />
            </Stack>
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="flex justify-start items-center space-x-2 mt-[2rem]">
        {reconciliationDoneToday === true ? (
          ""
        ) : (
          <button
            style={{ backgroundColor: coloredTheme }}
            onClick={() => navigate("/loans/detail")}
            className="px-[2rem] rounded-lg  text-white space-x-2 py-[0.5rem]  flex justify-center items-center  hover:font-[600] change-bg hover:shadow-2xl hover:shadow-black transition duration-[3s]">
            <IoAdd />
            <span>New Loan</span>
          </button>
        )}
        <button
          style={{ backgroundColor: coloredTheme }}
          onClick={() => navigate("/home")}
          className="px-[2rem] rounded-lg  text-white space-x-2 py-[0.5rem]  flex justify-center items-center  hover:font-[600] change-bg hover:shadow-2xl hover:shadow-black transition duration-[3s]">
          <IoExitOutline />
          <span>Exit</span>
        </button>
      </div>

      <Modal
        open={openLoanCloseReason}
        onClose={() => setOpenLoanCloseReason(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="md:w-[75%] w-[95%]  rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">
                  Please Provide a Reason For Closing the Loan
                </p>
              </div>
              <Divider />

              <div className="p-[0.8rem]">
                <div className="md:grid grid-cols-12 md:gap-x-6 mb-3">
                  {/* left wrapper */}
                  <div className="col-span-6 flex flex-col items-start justify-start space-y-4">
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Customer Nickname</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.customer_nickname}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Customer Name</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.customer_name}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Pays Customer Stamp</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.pay_stamp === true
                          ? "Yes"
                          : "No"}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Agent</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.agent}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Loan Number</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.loan_number}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Loan Product</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.loan_product}
                      </p>
                    </div>
                  </div>
                  {/* right wrapper */}
                  <div className="col-span-6 flex flex-col items-start justify-start space-y-4">
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Start Date</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {loanOverViewStartDate}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">
                        Total Advance Payments (+Days)
                      </p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.total_advance_payment}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">
                        Total Days No Payment (-Days)
                      </p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.total_days_no_payment}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">
                        {currentLoanOverViewDetail.loan_status === "Closed"
                          ? "Loan Closed (Days)"
                          : currentLoanOverViewDetail.loan_status ===
                            "Defaulted"
                          ? "Loan Defaulted (Days)"
                          : currentLoanOverViewDetail.loan_status === "Error"
                          ? "Loan Raised in Error (Days)"
                          : " Number of payment ahead/behind"}
                      </p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.no_payment_ahead_behind}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">
                        {currentLoanOverViewDetail.loan_status === "Closed"
                          ? "Loan Close Date"
                          : currentLoanOverViewDetail.loan_status ===
                            "Defaulted"
                          ? "Last Transaction Date"
                          : currentLoanOverViewDetail.loan_status === "Error"
                          ? ""
                          : "  Number of Payment Remaining"}
                      </p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {" "}
                        {currentLoanOverViewDetail.no_of_payment_remaining}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Customer Stamp</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {"MYR "}
                        {currentLoanOverViewDetail.customer_stamp}
                      </p>
                    </div>
                  </div>
                </div>

                <Divider />

                <div className="p-[0.5rem] mt-2">
                  {/* claim date (Required) */}
                  <div className="grid grid-cols-4 ">
                    <label
                      htmlFor="claimReason"
                      className="flex justify-start items-center col-span-1 space-x-1">
                      <span className="text-gray-700">Reason</span>
                    </label>

                    <div className="flex items-center col-span-3">
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          id="claimReason"
                          name="radio-buttons-group"
                          value={closeLoanReason}
                          onChange={(e) => setCloseLoanReason(e.target.value)}
                          row>
                          <FormControlLabel
                            value={"customer_satisfaction"}
                            control={<Radio />}
                            label=" Customer Satisfaction"
                          />
                          <FormControlLabel
                            value={"open_in_error"}
                            control={<Radio />}
                            label="Open in Error"
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>

                  <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                    <button
                      style={{ backgroundColor: coloredTheme }}
                      onClick={() => {
                        setCloseLoanReason("");
                        console.log("here:::::::::", openLoanCloseReason);
                        setOpenLoanCloseReason(false);
                      }}
                      className="flex justify-center items-center space-x-2  text-purple-50 px-[1rem] py-[0.5rem] rounded  hover:bg-purple-50  hover:shadow-2xl hover:shadow-black">
                      <TbArrowBackUp />
                      <p>Cancel</p>
                    </button>
                    <button
                      style={{ backgroundColor: coloredTheme }}
                      onClick={() => closeLoanHandler()}
                      className="flex justify-center items-center space-x-2  text-green-50 px-[1rem] py-[0.5rem] rounded  hover:bg-green-50  hover:shadow-2xl hover:shadow-black ">
                      <RiSave2Fill />
                      <p>Close Loan</p>
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      <Modal
        open={showCloseLoanHandler}
        onClose={() => setShowCloseLoanHandler(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="md:w-[75%] w-[95%] rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">
                  Please Provide Reason for Customer Satisfaction Reason
                </p>
              </div>
              <Divider />

              <div className="p-[0.8rem]">
                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="date"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Reason :</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setCustomerSatisfactionReason(e.target.value)
                    }
                    value={customerSatisfactionReason}
                    type="text"
                    id="textReason"
                    className="p-[0.5rem] border border-gray-500 rounded-lg flex-1 outline-none col-span-4"
                    placeholder="Enter A Reason for customer satisfaction"
                  />
                </div>
              </div>

              <div className="p-[0.8rem] flex justify-center items-center space-x-[0.8rem]">
                <button className="px-8 py-3 rounded bg-green-400 text-green-100 hover:bg-green-100 hover:text-white transition duration-[0.3s]">
                  Close
                </button>
                <button>Save</button>
              </div>
            </>
          )}
        </Box>
      </Modal>

      {/* LOAN OVERVIEW */}
      <Modal
        open={loanOverViewScreen}
        onClose={() => setLoanOverViewScreen(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="md:w-[70%] w-[95%] rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {currentLoanOverViewLoading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Loan Detail</p>
              </div>
              <Divider />

              <div className="p-[0.5rem]">
                <div className="md:grid grid-cols-12 md:gap-x-6">
                  {/* left wrapper */}
                  <div className="col-span-6 flex flex-col items-start justify-start space-y-4">
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Customer Nickname</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.customer_nickname}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Customer Name</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.customer_name}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Pays Customer Stamp</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.pay_stamp === true
                          ? "Yes"
                          : "No"}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Agent</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.agent}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Loan Number</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.loan_number}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Loan Product</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.loan_product}
                      </p>
                    </div>
                  </div>
                  {/* right wrapper */}
                  <div className="col-span-6 flex flex-col items-start justify-start space-y-4">
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Start Date</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {loanOverViewStartDate}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">
                        Total Advance Payments (+Days)
                      </p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.total_advance_payment}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">
                        Total Days No Payment (-Days)
                      </p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.total_days_no_payment}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">
                        {currentLoanOverViewDetail.loan_status === "Closed"
                          ? "Loan Closed (Days)"
                          : currentLoanOverViewDetail.loan_status ===
                            "Defaulted"
                          ? "Loan Defaulted (Days)"
                          : currentLoanOverViewDetail.loan_status === "Error"
                          ? "Loan Raised in Error (Days)"
                          : " Number of payment ahead/behind"}
                      </p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {currentLoanOverViewDetail.no_payment_ahead_behind}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">
                        {currentLoanOverViewDetail.loan_status === "Closed"
                          ? "Loan Close Date"
                          : currentLoanOverViewDetail.loan_status ===
                            "Defaulted"
                          ? "Last Transaction Date"
                          : currentLoanOverViewDetail.loan_status === "Error"
                          ? ""
                          : "  Number of Payment Remaining"}
                      </p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {" "}
                        {currentLoanOverViewDetail.no_of_payment_remaining}
                      </p>
                    </div>
                    <div className="w-[100%] flex justify-start items-center ">
                      <p className="py-2 w-[50%]">Customer Stamp</p>
                      <p className="py-2 w-[50%] border border-gray-300 rounded-lg px-6">
                        {"MYR "}
                        {currentLoanOverViewDetail.customer_stamp}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="w-[100%] mt-[4rem] md:flex justify-start items-center md:space-x-6 space-y-2 md:space-y-0">
                  <button
                    onClick={() =>
                      navigate(
                        `/transaction/list?loanHeader=${currentLoanCustomerData.id_number}`
                      )
                    }
                    className="md:px-8 py-3 w-[100%] md:text-[0.8rem] xl:text-[1rem] md:w-auto rounded bg-[#f59e0b] text-white hover:bg-yellow-100 hover:text-[#f59e0b] transition duration-[0.3s]">
                    List Transactions
                  </button>
                  <button className="md:px-8 py-3 w-[100%] md:text-[0.8rem] xl:text-[1rem] md:w-auto rounded bg-[#0d9488] text-white hover:bg-teal-100 hover:text-[#0d9488] transition duration-[0.3s]">
                    Payment Overview
                  </button>
                  {userDataFromStorage.user_role === "admin" ||
                  userDataFromStorage.user_role === "manager" ? (
                    <button
                      onClick={() => setNewTransactionModelOpen(true)}
                      className="md:px-8 py-3 w-[100%] md:w-auto rounded md:text-[0.8rem] xl:text-[1rem] bg-[#9333ea] text-white hover:bg-purple-100 hover:text-[#9333ea] transition duration-[0.3s]">
                      New Transaction
                    </button>
                  ) : (
                    ""
                  )}
                  {userDataFromStorage.user_role === "admin" ||
                  userDataFromStorage.user_role === "manager" ? (
                    <button
                      onClick={() =>
                        navigate(
                          `/loan_head/overview/${currentLoanCustomerData.id_number}`
                        )
                      }
                      className="md:px-8 py-3 w-[100%] md:w-auto rounded md:text-[0.8rem] xl:text-[1rem] bg-[#22c55e] text-white hover:bg-teal-100 hover:text-[#22c55e] transition duration-[0.3s]">
                      Edit Loan
                    </button>
                  ) : (
                    ""
                  )}
                  <button
                    onClick={() => setLoanOverViewScreen(false)}
                    className="md:px-8 py-3 w-[100%] md:w-auto rounded md:text-[0.8rem] xl:text-[1rem] bg-[#f43f5e] text-white hover:bg-rose-100 hover:text-[#f43f5e] transition duration-[0.3s]">
                    Cancel
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      <Modal
        open={newTransactionModelOpen}
        onClose={() => setNewTransactionModelOpen(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="md:w-[50%] w-[95%]  rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">New Payment Collection</p>
              </div>
              <Divider />

              <div className="p-[0.5rem]">
                {/* Transaction date (Required) */}
                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="date"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Transaction Date</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setAddTransactionPayload((prevState) => ({
                        ...prevState,
                        transaction_date: e.target.value,
                      }))
                    }
                    value={addTransactionPayload.transaction_date}
                    type="date"
                    id="date"
                    className="p-[0.5rem] border border-gray-500 rounded-lg flex-1 outline-none col-span-4"
                    placeholder="Enter A Transaction Date"
                  />
                </div>

                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="amt-outstanding"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Amount Outstanding</span>
                  </label>
                  <p className="col-span-4">
                    {loanHeaderList.amount_remaining !== null
                      ? `MYR ${loanHeaderList.amount_remaining}`
                      : "---"}
                  </p>
                </div>

                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="std-pay-amt"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">
                      Standard Payment Amount
                    </span>
                  </label>
                  <p className="col-span-4">
                    {loanHeaderList
                      ? `MYR ${loanHeaderList.collection_amount}`
                      : "---"}
                  </p>
                </div>

                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="trac-amt"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Transaction Amount</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setAddTransactionPayload((prevState) => ({
                        ...prevState,
                        transaction_amount: e.target.value,
                      }))
                    }
                    value={addTransactionPayload.transaction_amount}
                    type="number"
                    id="trac-amt"
                    className="p-[0.5rem] border border-gray-500 rounded-lg flex-1 outline-none col-span-4"
                    placeholder="Enter A Transaction Amount"
                  />
                </div>

                <div className="grid grid-cols-6 m-[0.3em]">
                  <label
                    htmlFor="new-colle-days"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">None Collection Days</span>
                  </label>
                  <div className="col-span-4 flex flex-col justify-center items-start ">
                    <input
                      onChange={(e) =>
                        setAddTransactionPayload((prevState) => ({
                          ...prevState,
                          none_collection_days: e.target.value,
                        }))
                      }
                      value={addTransactionPayload.none_collection_days}
                      type="number"
                      id="new-colle-days"
                      className="p-[0.5rem] border border-gray-500 rounded-lg flex-1 outline-none w-[100%]"
                      placeholder="Enter None Collection Days"
                    />
                    <small className="text-[0.9rem] text-gray-600 font-[600] opacity-50">
                      Customer or Agent away, for these number of days
                    </small>
                  </div>
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    onClick={() => setNewTransactionModelOpen(false)}
                    className="flex justify-center items-center space-x-2 bg-purple-400 text-purple-50 px-[1rem] py-[0.5rem] rounded hover:text-purple-500 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    onClick={() => addTransactionHandler()}
                    className="flex justify-center items-center space-x-2 bg-green-400 text-green-50 px-[1rem] py-[0.5rem] rounded hover:text-green-500 hover:bg-green-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default Loans;
